"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const defaultFonts = 'Helvetica, Tahoma, Geneva, Arial, sans-serif';
const dynamicStyles = ({ textAlign }) => ({
    textAlign,
});
const headline1 = styled_1.default.h1({
    margin: 0,
    fontSize: 48,
    fontFamily: `GT-Pressura-Ti-Bold, Calibre, ${defaultFonts}`,
}, dynamicStyles);
const headline2 = styled_1.default.h2({
    margin: 0,
    fontSize: 44,
    fontWeight: 600,
    fontFamily: `Calibre, ${defaultFonts}`,
}, dynamicStyles);
const headline3 = styled_1.default.h3({
    margin: 0,
    fontSize: 40,
    lineHeight: '25px',
    fontFamily: `Calibre, ${defaultFonts}`,
}, dynamicStyles);
const headline4 = styled_1.default.h4({
    margin: 0,
    fontSize: 32,
    fontFamily: `Calibre, ${defaultFonts}`,
}, dynamicStyles);
const headline5 = styled_1.default.h5({
    margin: 0,
    fontSize: 26,
    fontFamily: `Calibre, ${defaultFonts}`,
}, dynamicStyles);
const headline6 = styled_1.default.h6({
    margin: 0,
    fontSize: 24,
    lineHeight: '24px',
    fontFamily: `Calibre, ${defaultFonts}`,
}, dynamicStyles);
const subtitle = styled_1.default.p({
    margin: 0,
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600,
    fontFamily: `Calibre, ${defaultFonts}`,
}, dynamicStyles);
const body = styled_1.default.p({
    margin: 0,
    marginTop: 4,
    fontSize: 14,
    fontFamily: `Calibre, ${defaultFonts}`,
}, dynamicStyles);
const types = {
    body,
    headline1,
    headline2,
    headline3,
    headline4,
    headline5,
    headline6,
    subtitle,
};
function Text(_a) {
    var { variant = 'body', children, text } = _a, rest = __rest(_a, ["variant", "children", "text"]);
    const Comp = types[variant];
    return (react_1.default.createElement(Comp, Object.assign({}, rest), text || children));
}
exports.default = Text;
